import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSortable } from '@dnd-kit/sortable';

import { EMPTY_COLUMN_PLACEHOLDER_PREFIX } from './customize-layout-provider';

import { messages } from './messages';
import style from './empty-column-placeholder.module.less';

type EmptyColumnPlaceholderProps = {
  columnName: string;
};

export const EmptyColumnPlaceholder = ({ columnName }: EmptyColumnPlaceholderProps) => {
  const id = `${EMPTY_COLUMN_PLACEHOLDER_PREFIX}${columnName}`;
  const { attributes, listeners, setNodeRef } = useSortable({ id, disabled: false });

  return (
    <div ref={setNodeRef} className={style['empty-column-placeholder']} {...attributes} {...listeners}>
      <FormattedMessage {...messages.emptyColumnPlaceholder} />
    </div>
  );
};
